<template>
    <div class="Page">

      <font-awesome-icon v-if="UserIsAdmin" icon="plus" title="Add" class="btn btn-primary pull-right" @click="ShowRecipeModal" />
      <h1>Recipes</h1>

      <el-table stripe style="width: 100%" :data="Recipes">
        <el-table-column
            v-for="column in tableColumns"
            :key="column.label"
            :min-width="column.minWidth"
            :prop="column.prop"
            :label="column.label"
        >
        </el-table-column>
        <el-table-column
            min-width="100"
            prop="tags"
            label="Weight Loss"
            :width="170"
            label-class-name="text-center"
            :filters="[{text: 'Weight Loss', value: '15'}]"
            :filter-method="filterWeightLoss"
            :filtered-value="$route.path.indexOf('WeightLoss') > -1 ? ['15'] : []"
        >
            <template v-slot:default="props">
                <div class="table-actions text-center">
                    <font-awesome-icon v-if="IsWeightLoss(props.row)" icon="check" class="text-success" />
                </div>
            </template>
        </el-table-column>
        <el-table-column
            min-width="100"
            prop="tags"
            label="Whole Meal"
            :width="170"
            label-class-name="text-center"
            :filters="[{text: 'Whole Meal', value: '17'}]"
            :filter-method="filterWholeMeal"
            :filtered-value="$route.path.indexOf('WholeMeals') > -1 ? ['17'] : []"
        >
            <template v-slot:default="props">
                <div class="table-actions text-center">
                    <font-awesome-icon v-if="IsWholeMeal(props.row)" icon="check" class="text-success" />
                </div>
            </template>
        </el-table-column>
        <el-table-column
            min-width="100"
            prop="tags"
            label="Breakfast"
            :width="145"
            label-class-name="text-center"
            :filters="[{text: 'Breakfast', value: '18'}]"
            :filter-method="filterBreakfast"
            :filtered-value="$route.path.indexOf('Breakfast') > -1 ? ['18'] : []"
        >
            <template v-slot:default="props">
                <div class="table-actions text-center">
                    <font-awesome-icon v-if="IsBreakfast(props.row)" icon="check" class="text-success" />
                </div>
            </template>
        </el-table-column>
        <el-table-column
            min-width="100"
            prop="tags"
            label="Lunch"
            :width="115"
            label-class-name="text-center"
            :filters="[{text: 'Lunch', value: '19'}]"
            :filter-method="filterLunch"
            :filtered-value="$route.path.indexOf('Lunch') > -1 ? ['19'] : []"
        >
            <template v-slot:default="props">
                <div class="table-actions text-center">
                    <font-awesome-icon v-if="IsLunch(props.row)" icon="check" class="text-success" />
                </div>
            </template>
        </el-table-column>
        <el-table-column :min-width="80" :width="140" fixed="right" label="Actions">
          <template v-slot:default="props">
            <div class="table-actions">
              <n-button
                  @click="handleView(props.$index, props.row)"
                  class="like"
                  type="info"
                  size="sm"
                  round
                  icon
              >
                <font-awesome-icon icon="eye" />
              </n-button>
              <n-button
                  v-if="UserIsAdmin"
                  @click="handleEdit(props.$index, props.row)"
                  class="edit"
                  type="warning"
                  size="sm"
                  round
                  icon
              >
                <font-awesome-icon icon="pencil" />
              </n-button>
              <n-button
                  v-if="UserIsAdmin"
                  @click="handleDelete(props.$index, props.row)"
                  class="remove"
                  type="danger"
                  size="sm"
                  round
                  icon
              >
                <font-awesome-icon icon="trash-can" />
              </n-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <modal :class="{show:modals.Recipe.show}" :show-close="true" headerClasses="justify-content-center" type="Large" :CloseFunc="CloseRecipeModal">
        <template v-slot:header>
          <h4 class="title title-up">{{ modals.Recipe.title }}</h4>
        </template>
        <Recipe
            :Recipe="modals.Recipe.Recipe"
            :InsertNew="modals.Recipe.InsertNew"
            :FormInputsSet="modals.Recipe.FormInputsSet"
            @SetFormInputs="SetRecipeFormInputs"
            @CloseRecipeModal="CloseRecipeModal"
        ></Recipe>
      </modal>

    </div>
</template>
<script>
import { Modal } from "@/components";
import { ElTable, ElTableColumn } from "element-plus";
import Recipe from '../Components/AddEditRecipe';

export default {
    name: 'Recipes',
    components: {
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        Modal,
        Recipe
    },
    data() {
        return {
            selectedTags: [],
            searchQuery: '',
            tableColumns: [
                {
                    prop: 'name',
                    label: 'Name',
                    minWidth: 100,
                }
            ],
            modals: {
                Recipe: {
                    show: false,
                    title: 'Insert New Recipe',
                    InsertNew: true,
                    FormInputsSet: false,
                    Recipe: {}
                }
            }
        };
    },
    computed: {
        Recipes() {
            return this.$store.getters.Recipes_GetAll();
        },
        Pagination() {
            return this.$store.getters.Recipes_GetPagination();
        },
        UserIsAdmin() {
            return this.$store.getters.UsersGetRole().level === 1;
        }
    },
    mounted() {
        this.GetRecipes();
    },
    methods: {
        GetRecipes() {
            this.$store.dispatch('Recipes_UpdateAll');
        },
        handleView(index, row) {
            this.$store.dispatch('Recipes_FindModal', row.id);
        },
        handleEdit(index, row) {
            this.modals.Recipe.Recipe = row;
            this.modals.Recipe.title = 'Edit Recipe';
            this.modals.Recipe.InsertNew = false;
            this.ShowRecipeModal();
        },
        handleDelete(index, row) {
            this.$store.dispatch('Recipes_Remove', row.id);
        },
        SetRecipeFormInputs() {
            this.modals.Recipe.FormInputsSet = true;
        },
        filterWeightLoss(value, row) {
            let Tag = this.IsWeightLoss(row);
            return typeof Tag !== 'undefined';
        },
        IsWeightLoss(Recipe) {
            return Recipe.tags.find(T => T.id === 15);
        },
        filterWholeMeal(value, row) {
            let Tag = this.IsWholeMeal(row);
            return typeof Tag !== 'undefined';
        },
        IsWholeMeal(Recipe) {
            return Recipe.tags.find(T => T.id === 17);
        },
        filterBreakfast(value, row) {
            let Tag = this.IsBreakfast(row);
            return typeof Tag !== 'undefined';
        },
        IsBreakfast(Recipe) {
            return Recipe.tags.find(T => T.id === 18);
        },
        filterLunch(value, row) {
            let Tag = this.IsLunch(row);
            return typeof Tag !== 'undefined';
        },
        IsLunch(Recipe) {
            return Recipe.tags.find(T => T.id === 19);
        },
        ShowRecipeModal() {
            this.modals.Recipe.FormInputsSet = false;
            this.modals.Recipe.show = true;
        },
        CloseRecipeModal() {
            this.modals.Recipe.Recipe = {};
            this.modals.Recipe.title = 'Insert New Recipe';
            this.modals.Recipe.InsertNew = true;
            this.modals.Recipe.FormInputsSet = false;
            this.modals.Recipe.show = false;
        }
    }
};
</script>
